import * as ReactGA from 'react-ga'
import _ from 'lodash'
import Network from '../network/network'
import gettEnv from '../../config/gettEnv'
import { AnalyticsEvent, AnalyticsEventMap, MixpanelEventMap, MixpanelPropertiesMap } from './events'
import env, { getScrumNumber } from '../env'
import { currentLocale } from '../../config/locales'

type RelayProperties = {
  'company_name'?: string
  env?: string
  'delivery_uuid'?: string
  'delivery_status'?: string
  'page_type'?: string
  country?: string
  [key: string]: string | undefined
}

const relayProperties: RelayProperties = { country: currentLocale().toUpperCase() }

const relayUrl = env() === 'prod'
  ? gettEnv.REACT_APP_MONITORING_RELAY_URL
  : gettEnv.REACT_APP_MONITORING_RELAY_URL.replace('scrum0', `scrum${getScrumNumber()}`)

const relayNetwork = new Network(relayUrl)

export const sendToRelay = (body: any) => relayNetwork.post('', body)

export const setRelayEventProperty = (key: string, value: string) => {
  relayProperties[key] = value
}

export enum AnalyticsProperty {
  CompanyName = 'dimension1' as any,
  Env = 'dimension2' as any,
  DeliveryUUID = 'dimension3' as any,
  Status = 'dimension4' as any,
}

class AnalyticsError {
  description: string

  fatal: boolean

  constructor(e: Error) {
    this.description = `${e.name} - ${e.message}`
    this.fatal = false
  }
}

export const setProperty = (property: AnalyticsProperty, value: string) => {
  const fields: ReactGA.FieldsObject = {
    [property]: value,
  }
  ReactGA.set(fields)

  setRelayEventProperty(MixpanelPropertiesMap[property], value)
}

export const sendCurrentPageView = (title: string = '') => {
  let pageTitle = window.location.pathname
  if (title) {
    pageTitle += ` - ${title}`
  }
  ReactGA.pageview(pageTitle)
}

export const sendEvent = (event: AnalyticsEvent, props: { [key: string]: any} = {}) => {
  const analyticsEventToSend = AnalyticsEventMap[event]
  ReactGA.event(analyticsEventToSend)

  const mixpanelEventToSend = MixpanelEventMap[event]

  if (mixpanelEventToSend) {
    sendToRelay({
      env: relayProperties.country,
      event: mixpanelEventToSend,
      properties: { ..._.omit(relayProperties, 'country'), ...props }
    }).catch(e => console.error('Events error:', e))
  }
}

export const reportError = (e: Error) => {
  ReactGA.exception(new AnalyticsError(e))
}

export const init = () => {
  ReactGA.initialize(gettEnv.REACT_APP_GOOGLE_ANALYTICS_ID)
  const currentEnv = env()
  setProperty(AnalyticsProperty.Env, currentEnv)
}

export { AnalyticsEvent as Event } from './events'
